import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BaseUrl = process.env.REACT_APP_API_URL;

export const ProjWiseClient = createAsyncThunk(
  "DBsync/ProjWiseClient",
  async (projectId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DBsync/ProjWiseClient/${projectId}`,
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const uploadBackup = createAsyncThunk(
  "DBsync/uploadBackup",
  async (formData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DBsync/UploadBackups`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const exeupload = createAsyncThunk(
  "DBsync/exeupload",
  async (formData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DBsync/UploadExe`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const notifyUpdate = createAsyncThunk(
  "DBsync/notifyUpdate",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(`${BaseUrl}/DBsync/NotifyUpdate`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to send notification"
      );
    }
  }
);

// NEWeeeeee
export const notifyDBUpdate = createAsyncThunk(
  "DBsync/notifyDBUpdate",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DBsync/NotifyDBUpdate`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to notify DB update"
      );
    }
  }
);

const DbExeUpdateSlice = createSlice({
  name: "dbExeUpdate",
  initialState: {
    projWiseClientsLoading: false,
    projWiseClientsError: null,
    projWiseClients: null,

    UploadBackupData: null,
    uploadBackupLoading: false,
    uploadBackupError: null,

    ExeuploadData: null,
    exeuploadLoading: false,
    exeuploadError: null,

    NotifyUpdateData: null,
    notifyUpdateLoading: false,
    notifyUpdateError: null,

    NotifyDBUpdateData: null,
    notifyDBUpdateLoading: false,
    notifyDBUpdateError: null,
  },

  reducers: {
    clearUploadData: (state) => {
      state.UploadBackupData = null;
      state.ExeuploadData = null;
      state.NotifyUpdateData = null;
      state.NotifyDBUpdateData = null;
      state.uploadBackupError = null;
      state.exeuploadError = null;
      state.notifyUpdateError = null;
      state.notifyDBUpdateError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Project Wise Clients
      .addCase(ProjWiseClient.pending, (state) => {
        state.projWiseClientsLoading = true;
      })
      .addCase(ProjWiseClient.fulfilled, (state, action) => {
        state.projWiseClientsLoading = false;
        state.projWiseClients = action.payload;
      })
      .addCase(ProjWiseClient.rejected, (state, action) => {
        state.projWiseClientsLoading = false;
        state.projWiseClientsError = action.payload;
      })

      // Upload Backup
      .addCase(uploadBackup.pending, (state) => {
        state.uploadBackupLoading = true;
      })
      .addCase(uploadBackup.fulfilled, (state, action) => {
        state.uploadBackupLoading = false;
        state.UploadBackupData = action.payload;
      })
      .addCase(uploadBackup.rejected, (state, action) => {
        state.uploadBackupLoading = false;
        state.uploadBackupError = action.payload;
      })

      // Upload EXE
      .addCase(exeupload.pending, (state) => {
        state.exeuploadLoading = true;
      })
      .addCase(exeupload.fulfilled, (state, action) => {
        state.exeuploadLoading = false;
        state.ExeuploadData = action.payload;
      })
      .addCase(exeupload.rejected, (state, action) => {
        state.exeuploadLoading = false;
        state.exeuploadError = action.payload;
      })

      // Notify Update
      .addCase(notifyUpdate.pending, (state) => {
        state.notifyUpdateLoading = true;
      })
      .addCase(notifyUpdate.fulfilled, (state, action) => {
        state.notifyUpdateLoading = false;
        state.NotifyUpdateData = action.payload;
      })
      .addCase(notifyUpdate.rejected, (state, action) => {
        state.notifyUpdateLoading = false;
        state.notifyUpdateError = action.payload;
      })

      // ⭐ NEW — Notify DB Update
      .addCase(notifyDBUpdate.pending, (state) => {
        state.notifyDBUpdateLoading = true;
      })
      .addCase(notifyDBUpdate.fulfilled, (state, action) => {
        state.notifyDBUpdateLoading = false;
        state.NotifyDBUpdateData = action.payload;
      })
      .addCase(notifyDBUpdate.rejected, (state, action) => {
        state.notifyDBUpdateLoading = false;
        state.notifyDBUpdateError = action.payload;
      });
  },
});

export const { clearUploadData } = DbExeUpdateSlice.actions;
export default DbExeUpdateSlice.reducer;
